module.exports = __webpack_public_path__ + "img/zzback.91232a29.png";